import { action, computed } from '@ember/object';
import AbstractCondition, { addError } from './abstract';

export const ever = 'ever';
export const recent = 'recent';

/*
  We store our event data for access by the segments system in summary
  objects, which contain:

  - total count of the event type
  - timestamps for first 20 events performed of that type
  - timestamps of most recent 20 events performed of that type

  This allows us to filter by any count since signing up, or by a time
  constraint count between 1 and 20.
*/
export const recentLimit = 20;

export const timesLimitExceededError = `must be at most ${recentLimit}`;

class RefinementCondition extends AbstractCondition {
  type = 'refinement';

  trackedAttributes = ['period', 'days', 'times'];

  period = ever;
  days = 1;
  times = 1;

  @computed('period', 'days', 'times')
  get errors() {
    let { period, days, times } = this.getProperties('period', 'days', 'times');
    let errors = {};

    if (isNaN(days)) {
      addError(errors, 'days', 'must be a number');
    }

    if (isNaN(times)) {
      addError(errors, 'times', 'must be a number');
    }

    if (days < 1) {
      addError(errors, 'days', 'must be at least 1');
    }

    if (times < 1) {
      addError(errors, 'times', 'must be at least 1');
    }

    if (period === recent && times > recentLimit) {
      addError(errors, 'times', timesLimitExceededError);
    }

    return errors;
  }

  @action
  duplicate() {
    let duplicate = RefinementCondition.create();
    this.copyAllAttributes(this, duplicate);
    return duplicate;
  }

  copyAllAttributes(source: RefinementCondition, target: RefinementCondition) {
    target.setProperties({
      _event: this.event,
      period: source.period,
      days: source.days,
      times: source.times,
    });
  }

  toString() {
    return 'RefinementCondition';
  }
}

export default RefinementCondition;
